import { render, staticRenderFns } from "./GameCard.vue?vue&type=template&id=32a8a27e&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"
import style0 from "./GameCard.vue?vue&type=style&index=0&id=32a8a27e&prod&lang=css"
import style1 from "./GameCard.vue?vue&type=style&index=1&id=32a8a27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a8a27e",
  null
  
)

export default component.exports